import { PhoneCall, HeartHandshake, Sprout } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { HexIcon } from "@/components/HexIcon";

const steps = [
  {
    num: "01",
    icon: PhoneCall,
    title: "Reach Out",
    body: "Call 479-437-5939, email Themadcohive@gmail.com, or send a message through this page. However you reach us, a real person answers with warmth.",
    testid: "step-card-reach-out",
  },
  {
    num: "02",
    icon: HeartHandshake,
    title: "Connect & Assess",
    body: "Sit down with a caring team member at our Huntsville office. We listen first, then map your family's unique needs together — no judgment, ever.",
    testid: "step-card-connect",
  },
  {
    num: "03",
    icon: Sprout,
    title: "Thrive Together",
    body: "Receive direct aid, peer mentorship, and ongoing connections to local resources. We stay in your corner for as long as you need us.",
    testid: "step-card-thrive",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="honeycomb-dark grain relative overflow-hidden bg-obsidian py-24 sm:py-32"
    >
      <div className="pointer-events-none absolute -top-40 left-1/2 h-[500px] w-[700px] -translate-x-1/2 rounded-full bg-[radial-gradient(circle,rgba(229,169,60,0.14),transparent_65%)] blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <p className="mb-3 text-xs font-bold uppercase tracking-[0.24em] text-amber-500" data-testid="how-eyebrow">
            Chapter 03 — Getting Connected
          </p>
          <h2 className="font-display text-3xl font-semibold tracking-tight text-[#F9F6EF] sm:text-4xl" data-testid="how-heading">
            Help in <span className="italic text-amber-400">three gentle steps.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-6">
          {steps.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.14}>
              <div className="group relative" data-testid={s.testid}>
                {i < steps.length - 1 && (
                  <div className="absolute left-full top-10 hidden h-px w-6 bg-gradient-to-r from-amber-500/50 to-transparent md:block" />
                )}
                <span className="text-outline-cream pointer-events-none absolute -top-10 right-0 font-display text-8xl font-bold">
                  {s.num}
                </span>
                <HexIcon size={72} dark>
                  <s.icon size={28} strokeWidth={1.8} />
                </HexIcon>
                <h3 className="mt-7 font-display text-xl font-semibold text-[#F9F6EF] sm:text-2xl">{s.title}</h3>
                <p className="mt-3 max-w-sm text-sm leading-relaxed text-neutral-400">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3}>
          <div className="mt-16 flex flex-wrap items-center gap-4">
            <a
              href="tel:4794375939"
              data-testid="how-call-btn"
              className="rounded-full bg-amber-500 px-7 py-3.5 text-sm font-bold text-obsidian transition-colors duration-300 hover:bg-amber-400"
            >
              Start with a call — 479-437-5939
            </a>
            <a
              href="mailto:Themadcohive@gmail.com"
              data-testid="how-email-btn"
              className="rounded-full border border-amber-500/60 px-7 py-3 text-sm font-bold text-amber-400 transition-colors duration-300 hover:bg-amber-500/10"
            >
              Email us instead
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
